import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { INVENTORY_LINKS_PAGES } from "@/constants/InventoryLinks";
import { clone } from "@/util/clone";

export function steelTypeDisplayValue(steelTypes) {
  const configStore = useConfigStore();
  return steelTypes?.map((s) => configStore.getReferenceValue(REFERENCE_TABLE.STEEL_TYPE, s))?.join(", ");
}

export function getSpanTypes(structureType) {
  const configStore = useConfigStore();
  const allSpanTypes = configStore.getReferenceValues(REFERENCE_TABLE.SPAN_TYPE);
  //if structure type is Sign or Light
  if (["S", "H"].includes(structureType) || structureType === INVENTORY_LINKS_PAGES.SIGNS_AND_LIGHTS) {
    return allSpanTypes.filter((s) =>
      ["HM01", "SS01", "SS02", "SS03", "SS04", "SS05", "SS06", "SS07", "SS08", "SS09", "SS10", "SS11"].includes(
        s.value,
      ),
    );
  } else if (["N", "R"].includes(structureType) || structureType === INVENTORY_LINKS_PAGES.WALLS) {
    //walls
    return allSpanTypes.filter((s) =>
      [
        "NW01",
        "NW02",
        "NW03",
        "NW04",
        "RW01",
        "RW02",
        "RW03",
        "RW04",
        "RW05",
        "RW06",
        "RW07",
        "RW08",
        "RW09",
        "RW10",
        "RW11",
        "RW12",
        "RW13",
      ].includes(s.value),
    );
  } else if (["T"].includes(structureType) || structureType === INVENTORY_LINKS_PAGES.TUNNELS) {
    return allSpanTypes.filter((s) => ["TUN"].includes(s.value));
  } else {
    return allSpanTypes;
  }
}

export function getMaxMinSpanLength(structureUnits, spanDesignations) {
  const spanLengthArr = structureUnits
    ?.filter(
      (a) =>
        a.spanLength &&
        a.spanLength != -1 &&
        spanDesignations?.includes(a.spanConfigDesignation?.[0]) &&
        ["M", "A"]?.includes(a.legacyStructureType),
    )
    .map((a) => a.spanLength);
  if (spanLengthArr && spanLengthArr.length > 0) {
    return {
      maxLength: Math.max(...spanLengthArr),
      minLength: Math.min(...spanLengthArr),
    };
  } else {
    return {
      maxLength: null,
      minLength: null,
    };
  }
}

export function filterStructureUnitsByLegacyType(structureUnits, unitTypes, toInclude) {
  let clonedStructureUnits = clone(structureUnits);
  if (toInclude) {
    return clonedStructureUnits?.filter((unit) => unitTypes.includes(unit.legacyStructureType));
  } else {
    //exclude the unit types
    return clonedStructureUnits?.filter((unit) => !unitTypes.includes(unit.legacyStructureType));
  }
}

export function convertStructureUnitsToLocations(structureUnits) {
  const configStore = useConfigStore();
  return structureUnits
    ?.map((b) => ({
      title: b.strUnitDescription
        ? `${b.strUnitDescription}-${b.strUnitLabel}`
        : `${configStore.getReferenceValue(REFERENCE_TABLE.STRUCTURE_UNIT_TYPE, b.legacyStructureType, true)}-${
            b.strUnitLabel
          }`,
      value: b.strUnitKey.toString(),
    }))
    .sort((a, b) => a.title.localeCompare(b.title));
}

export function getMinimumOut2OutWidthDisplay(structureUnits) {
  let minimum = -1;
  let out2OutValues = structureUnits
    ?.filter((su) => !!su.minSpanOut2OutWidth && su.minSpanOut2OutWidth > 0)
    ?.map((su) => su.minSpanOut2OutWidth);
  if (out2OutValues?.length > 0) {
    minimum = Math.min(...out2OutValues);
  }
  return minimum;
}
